import { createThunkRoutine } from 'redux-thunk-routine';
import {
  FETCH_PRODUCTS_DATA,
  FETCH_LICENSES_DATA,
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
  CREATE_LICENSE,
  ASSIGN_LICENSE,
  REMOVE_LICENSE_FROM_CUSTOMER,
  EDIT_ASSIGNED_LICENSE,
  UPDATE_LICENSE,
  DELETE_LICENSE,
  GET_LICENSE_ROLES,
  GET_USERS_FOR_LICENSE,
  ASSIGN_USER_TO_LICENSE,
  UN_ASSIGN_USER_FROM_LICENSE,
} from './action-types';

export const FetchProductsRoutine = createThunkRoutine(FETCH_PRODUCTS_DATA);
export const FetchLicensesRoutine = createThunkRoutine(FETCH_LICENSES_DATA);
export const CreateProductRoutine = createThunkRoutine(CREATE_PRODUCT);
export const UpdateProductRoutine = createThunkRoutine(UPDATE_PRODUCT);
export const DeleteProductRoutine = createThunkRoutine(DELETE_PRODUCT);

export const CreateLicenseRoutine = createThunkRoutine(CREATE_LICENSE);
export const UpdateLicenseRoutine = createThunkRoutine(UPDATE_LICENSE);
export const DeleteLicenseRoutine = createThunkRoutine(DELETE_LICENSE);

export const AssignLicenseRoutine = createThunkRoutine(ASSIGN_LICENSE);

export const RemoveLicenseFromCustomerRoutine = createThunkRoutine(REMOVE_LICENSE_FROM_CUSTOMER);
export const AssignLicenseEditRoutine = createThunkRoutine(EDIT_ASSIGNED_LICENSE);

export const GetLicenseRolesRoutine = createThunkRoutine(GET_LICENSE_ROLES);
export const GetUsersForLicenseRoutine = createThunkRoutine(GET_USERS_FOR_LICENSE);
export const AssignLicenseToUserRoutine = createThunkRoutine(ASSIGN_USER_TO_LICENSE);
export const UnAssignLicenseFromUserRoutine = createThunkRoutine(UN_ASSIGN_USER_FROM_LICENSE);
